import React, { useContext, useEffect } from "react";
import { AuthContext } from "../context/Auth/AuthContext";
import { hasRolloutFeature, ROLLOUT_FEATURES } from "../utils/rolloutFeatures";
import { startPushAutoRepair } from "../services/pushNotification";
import LegacyLayout from "./Legacy";
import RolloutLayout from "./Rollout";

const LoggedInLayout = props => {
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (!user?.id) return undefined;
    return startPushAutoRepair();
  }, [user?.id]);

  const Component = hasRolloutFeature(user, ROLLOUT_FEATURES.TICKETS_UI)
    ? RolloutLayout
    : LegacyLayout;
  return <Component {...props} />;
};

export default LoggedInLayout;
